'use strict';

(function ($) {

    // Substitute jQuery validation mechanism with globalized mechanism.
    // Depends on IG globalization files, to pull out formats and delimiters.
    // If IG globalization file is not acceptible, correct this module.
    if (!$.validator || !$.validator.methods) {
        return;
    }

    $.validator.addMethod(
        'validatepassword', function (value, element, params) {

            var blacklistedWords = ["password"];

            var valid = true;
            try {
                // at least one digit
                if (!/\d/.test(value)) {
                    valid = false;
                }
                // at least one lowercase letter
                if (!/[a-z]/.test(value)) {
                    valid = false;
                }

                // at least one uppercase letter
                if (!/[A-Z]/.test(value)) {
                    valid = false;
                }
                // x26->& x2D->-
                if (!/^(?=.*[!@#$%^*()_+|~=\\{}[\]:?,.\/\x26\x2D])/.test(value)) {
                    valid = false;
                }
                // at least one non-alphanumeric character
                if (!/^(?=.*[^\da-zA-Z])/.test(value)) {
                    valid = false;
                }

                // character not allowed more than two times
                if (/(.)\1{2,}/.test(value)) {
                    valid = false;
                }

                // length between 8 and 50 characters
                if (!/^(.{8,50})$/.test(value)) {
                    valid = false;
                }

                // check if password contains blacklisted words 
                if (blacklistedWords.some(function (v) { return value.indexOf(v) >= 0; })) {
                    valid = false;
                }

                //Not allowed: blank(), semicolons(;), en - Dash(�), em - Dash(�), �Inverted Commas ( ��)
                if (value.indexOf(' ') !== -1 || value.indexOf(';') !== -1 || value.indexOf('\u2013') !== -1 || value.indexOf('\u2014') !== -1 ||
                    value.indexOf('"') !== -1 || value.indexOf('\'') !== -1 || value.indexOf('<') !== -1 || value.indexOf('>') !== -1) {
                    valid = false;
                }
            }
            catch (err) {
                valid = false;
            }

            return valid;
        });


    $.validator.unobtrusive.adapters.add(
        'validatepassword', ['pass'], function (options) {
            var params = {
                pass: options.params.pass
            };
            options.rules['validatepassword'] = params;
            options.messages['validatepassword'] = options.message;
        });


    $.validator.addMethod("accept", function (value, element, param) {

        // resolve actual file control (specific for DbFileControl)
        element = $(element.parentElement).find('input[type="file"]')[0];

        if (!$(element).attr("accept") || $(element).attr("accept") === 'false')
            return true;

        if (typeof param === "string") {
            var typeParam = param.replace(/\s/g, "").toUpperCase();
            var i, file, fileExt, fileParts;

            if (element.files && element.files.length) {
                var typeArray = typeParam.split(",");

                for (i = 0; i < element.files.length; i++) {
                    file = element.files[i];

                    if (file) {
                        fileParts = file.name.split(".");
                        fileExt = "." + fileParts[fileParts.length - 1].toUpperCase();
                        if (typeArray.indexOf(file.type.toUpperCase()) === -1 && typeArray.indexOf(fileExt) === -1) {
                            return false;
                        }
                    }
                }
            }
        }

        return true;
    });

    $.validator.addMethod("maxsize", function (value, element, param) {

        if (!$(element).attr("maxsize") || $(element).attr("maxsize") === 'false')
            return true;

        // resolve actual file control (specific for DbFileControl)
        element = $(element.parentElement).find('input[type="file"]')[0];

        var maxSize = param;
        var i, len, file;

        if ($(element).attr("type") === "file") {
            if (element.files && element.files.length) {
                len = element.files.length;

                for (i = 0; i < len; i++) {
                    file = element.files[i];
                    var sizeInKb = file.size / 1000;
                    if (sizeInKb > maxSize) {
                        return false;
                    }
                }
            }
        }

        return true;
    });

    $.validator.addMethod("defaultLanguage", function (value, element, param) {
        if (!$(element).attr("defaultLanguage") || $(element).attr("defaultLanguage") === 'false')
            return true;

        var val = "";

        if ($(element).hasClass("summernote") || $(element).hasClass("tinymce"))
            val = $(element).closest('.ag-multilang-control-with-richtextarea').find('input[type="hidden"]').val();
        else
            val = $(element).closest(".ag-multilang-control").find('input:hidden[name]').val();

        var languages = JSON.parse(val);

        return languages[param] && $.trim(languages[param]).length > 0;
    });

    $.validator.addMethod("emailmultiple", function (value, element) {
        return this.optional(element) || /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(;[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/.test(value);
    },);

    if (!$.ig || !$.ig.regional || !$.ig.regional.defaults) {
        return;
    }

    var ngSeparator = $.ig.regional.defaults.numericGroupSeparator;
    var ndSeparator = $.ig.regional.defaults.numericDecimalSeparator || '.';
    var ngNumberCount = $.ig.regional.defaults.numericGroups || [3];
    ngNumberCount = (ngNumberCount.length === 0 ? 3 : ngNumberCount[0]);
    var numberFormat = new RegExp('^-?(?:\\d+' + (ngSeparator ? ('|\\d{1,' + ngNumberCount + '}(?:' + (ngSeparator === '.' ? '\\.' : ngSeparator) + '\\d{' + ngNumberCount + '})+)?') : '') + '(?:' + (ndSeparator === '.' ? '\\.' : ndSeparator) + '\\d+)?$');

    // functions used by validators
    var dateTimeTokenToRegex = function (token) {
        switch (token) {
            case 'd':
                return '(?:[1-9]|[12][0-9]|3[01])';
            case 'dd':
                return '(?:[0-2][0-9]|3[01])';
            case 'ddd':
                return '(?:' + $.ig.regional.defaults.dayNamesShort.join('|') + ')';
            case 'dddd':
                return '(?:' + $.ig.regional.defaults.dayNames.join('|') + ')';
            case 'M':
                return '(?:[1-9]|1[0-2])';
            case 'MM':
                return '(?:0[1-9]|1[0-2])';
            case 'MMM':
                return '(?:' + $.ig.regional.defaults.monthNamesShort.join('|') + ')';
            case 'MMMM':
                return '(?:' + $.ig.regional.defaults.monthNames.join('|') + ')';
            case 'yy':
                return '(?:\\d{2})';
            case 'yyy':
                return '(?:\\d{3})';
            case 'yyyy':
                return '(?:\\d{4})';
            case 'h':
                return '(?:[1-9]|1[0-2])';
            case 'hh':
                return '(?:0[1-9]|1[0-2])';
            case 'H':
                return '(?:(?:1)?[0-9]|2[0-4])';
            case 'HH':
                return '(?:[01][0-9]|2[0-4])';
            case 'mm':
                return '(?:[0-5][0-9])';
            case 'ss':
                return '(?:[0-5][0-9])';
            case 'tt':
                return '(?:' + $.ig.regional.defaults.am + '|' + $.ig.regional.defaults.pm + ')';
        }
    };


    var dateTimeRegexBuilder = function (format) {
        var regex = '';
        var currentToken = '';

        for (var i = 0; i < format.length; ++i) {
            var c = format.charAt(i);
            if (c === 'd' || c === 'M' || c === 'y' || c === 'h' || c === 'H' || c === 'm' || c === 's' || c === 't') {
                if (currentToken === '' || currentToken.charAt(0) === c) {
                    currentToken += c;
                } else {
                    regex += dateTimeTokenToRegex(currentToken);
                    currentToken = '';
                }
            } else {
                if (currentToken !== '') {
                    regex += dateTimeTokenToRegex(currentToken);
                    currentToken = '';
                }
                regex += (c === '.' ? '\\.' : c);
            }
        }
        if (currentToken !== '') {
            regex += dateTimeTokenToRegex(currentToken);
        }
        return new RegExp(regex);
    };




    var transformNumberRegex = new RegExp('-|' + (ngSeparator === '.' ? '\\.' : ngSeparator) + '|' + (ndSeparator === '.' ? '\\.' : ndSeparator), 'g');
    var globalizedNumberParse = function (value) {
        if (!value || !numberFormat.test(value)) return null;

        var negative = false;
        value = value.replace(transformNumberRegex, function (symbol) {
            switch (symbol) {
                case '-':
                    negative = true;
                    return '';
                case ngSeparator:
                    return '';
                case ndSeparator:
                    return '.';
            }
        });

        if (value.charAt(0) === '.') {
            value = '0' + value;
        }

        var number = Number(value);
        if (isNaN(number)) return null;

        if (negative) number = -number;
        return number;
    };

    // validator overrides
    var base = {
        min: $.validator.methods.min,
        max: $.validator.methods.max,
        range: $.validator.methods.range,
        maxlength: $.validator.methods.maxlength
    };

    var shortDateFormat = dateTimeRegexBuilder($.ig.regional.defaults.datePattern);
    var longDateFormat = dateTimeRegexBuilder($.ig.regional.defaults.dateLongPattern);

    $.validator.methods.required = function (value, element, param) {
        // check if dependency is met
        if (!this.depend(param, element))
            return "dependency-mismatch";
        switch (element.nodeName.toLowerCase()) {
            case 'select':
                // could be an array for select-multiple or a string, both are fine this way
                var val = $(element).val();
                return val && val.length > 0;
            case 'input':
                // could be IG editor: since we have input masks, we must must check with editor for validity
                var $element = $(element);
                var igEditor = $element.data('uiIgDatePicker') || $element.data('uiIgDateEditor') || $element.data('uiIgMaskEditor') || $element.data('uiIgPercentEditor');
                var igCombo = $element.data('uiIgCombo');
                if (igEditor) {
                    return igEditor.isValid() && igEditor.value() != null;
                }
                else if (igCombo) {
                    return igCombo.value() != null && igCombo.value() != "";
                }
                else if (this.checkable(element)) {
                    return this.getLength(value, element) > 0;
                }
            default:
                return $.trim(value).length > 0;
        }
    };

    $.validator.methods.number = function (value, element) {
        var result = this.optional(element) || numberFormat.test(value);

        if (!result) {
            var $element = $(element);
            var igEditor = $element.data('uiIgDatePicker') || $element.data('uiIgDateEditor') || $element.data('uiIgMaskEditor') || $element.data('uiIgPercentEditor');
            if (igEditor) {
                return igEditor.value() != null;
            }
        }

        return result;
    };

    $.validator.methods.date = function (value, element) {
        var $element = $(element).parent().parent().find('input[type!=hidden]');
        var igDateEditor = $element.data('uiIgDatePicker') || $element.data('uiIgDateEditor');
        if (igDateEditor) {
            // if we have editor, check validity with editor
            return this.optional(element) || igDateEditor.isValid();
        } else {
            return this.optional(element) || shortDateFormat.test(date) || longDateFormat.test(date);
        }
    };

    $.validator.methods.min = function (value, element, param) {
        var number = globalizedNumberParse(value);
        return base.min.call(this, number, element, param);
    };

    $.validator.methods.max = function (value, element, param) {
        var number = globalizedNumberParse(value);
        return base.max.call(this, number, element, param);
    };

    $.validator.methods.range = function (value, element, param) {

        var number = globalizedNumberParse(value);
        var result = base.range.call(this, number, element, param);

        if (!result) {
            var $element = $(element);

            var igEditor = $element.data('uiIgPercentEditor');
            if (igEditor && igEditor.value() != '') {
                number = Number(igEditor.value() * 100);
                return base.range.call(this, number, element, param);
            }
        }

        return result;
    };

    $.validator.addMethod("requiredifotherfieldhasvalue", function (value, element, params) {
        if (($(params).val() == null || $(params).val() == "" || $(params).prop('checked') === false) || (value != null && value != "")) {
            //$("[for=" + element.id + "]").parent().removeClass("required");
            return true;
        }
        //$("[for=" + element.id + "]").parent().addClass("required");
        return false;
    });
    $.validator.unobtrusive.adapters.add("requiredifotherfieldhasvalue", ["otherpropertyname"], function (options) {
        options.rules["requiredifotherfieldhasvalue"] = "#" + options.params.otherpropertyname;
        options.messages["requiredifotherfieldhasvalue"] = options.message;
    });

	/*$.validator.addMethod("numbergreaterthan", function (value, element, params) {
	    if ($(params).igNumericEditor("value") === null || globalizedNumberParse(value) === null) {
	        return true;
	    }
        return globalizedNumberParse(value) >= $(params).igNumericEditor("value");

	});*/

    $.validator.unobtrusive.adapters.add("numbergreaterthan", ["otherpropertyname"], function (options) {
        options.rules["numbergreaterthan"] = "#" + options.params.otherpropertyname;
        options.messages["numbergreaterthan"] = options.message;
    });

	/*$.validator.addMethod("numberlesserthan", function (value, element, params) {
	    if ($(params).igNumericEditor("value") === null || globalizedNumberParse(value) === null) {
	        return true;
	    }
	    return globalizedNumberParse(value) <= $(params).igNumericEditor("value");
	});*/

    $.validator.unobtrusive.adapters.add("numberlesserthan", ["otherpropertyname"], function (options) {
        options.rules["numberlesserthan"] = "#" + options.params.otherpropertyname;
        options.messages["numberlesserthan"] = options.message;
    });

	/*$.validator.addMethod("numberbetween", function (value, element, params) {
	    var minMax = [$(params.otherpropertyname1).igNumericEditor("value"), $(params.otherpropertyname2).igNumericEditor("value")];
	    var min = Math.min.apply(null, minMax), max = Math.max.apply(null, minMax);
	    if (globalizedNumberParse(value) === null || minMax[0] === null || minMax[1] === null) {
	        return true;
	    }
	    return globalizedNumberParse(value) >= min && globalizedNumberParse(value) <= max;
	});*/

    $.validator.unobtrusive.adapters.add("numberbetween", ["otherpropertyname1", "otherpropertyname2"], function (options) {
        options.rules['numberbetween'] = {
            otherpropertyname1: "#" + options.params.otherpropertyname1,
            otherpropertyname2: "#" + options.params.otherpropertyname2
        };
        options.messages["numberbetween"] = options.message;
    });

    var numberGroupRegex = new RegExp((ngSeparator === '.' ? '\\.' : ngSeparator), 'g');
    $.validator.methods.maxlength = function (value, element, param) {
        if ($(element).attr('data-val-number')) value = value.replace(numberGroupRegex, '');
        return base.maxlength.call(this, value, element, param);
    };
})($);

// integrate bootstrap validation
(function ($) {
    var base = {
        highlight: $.validator.defaults.highlight,
        unhighlight: $.validator.defaults.unhighlight
    };

    function getValidationElement(element) {
        var $elements = $(element).closest('.ag-field, td').find('input:not([type="hidden"], [type="file"]), .validated-element');
        var $el = $(element);
        var i;

        if ($el.is('input[type="hidden"], input[type="file"]')) {
            for (i = 0; i < $elements.length; i++) {
                var $el2 = $($elements[i]);
                if (!$el2.is('input[type="hidden"], input[type="file"]')) {
                    $el = $el2;
                    break;
                }
            }
        }

        return $el;
    }

    $.validator.unobtrusive.options ??= {};
    $.validator.unobtrusive.options.success = function (label, element) {
        var $el = getValidationElement(element);

        $el.closest(".validation-node").find('[data-type="validation-message"]').remove();

        $el.closest(".form-group, .validation-node").find("button:not(.note-btn)").removeClass("has-error");
        $el.closest(".form-group, .validation-node").find(".input-validation-error").removeClass("input-validation-error");
        $el.closest('.form-group, .validation-node, td').removeClass('has-error has-feedback').find('span.form-control-feedback').hide();
    };

    $.validator.setDefaults({
        ignore: '.input[type="hidden"]:not(.validate-hidden), .validate-ignore, .note-input',
        
        onfocusout: false,
        highlight: function (element, errorClass, validClass, message) {
            var $el = getValidationElement(element);

            base.highlight.call(this, $el, errorClass, validClass);

            const validationElement = $el.closest(".validation-node");

            if (validationElement.length) {
                validationElement.find('[data-type="validation-message"]').remove();
                validationElement[0].appendChild($(`<div class="text-danger" data-type="validation-message">${message}</div>`)[0]);
            }

            $el.closest(".form-group, .validation-node").find("button:not(.note-btn)").addClass("has-error");
            $el.closest('.form-group, .validation-node, td').addClass('has-error has-feedback').find('span.form-control-feedback').show();
        },
        unhighlight: function (element, errorClass, validClass) {
            var $el = getValidationElement(element);

            $el.closest(".form-group, .validation-node").find("button:not(.note-btn)").removeClass("has-error");
            $el.closest(".form-group, .validation-node").find(".input-validation-error").removeClass("input-validation-error");
            $el.closest('.form-group, .validation-node, td').removeClass('has-error has-feedback').find('span.form-control-feedback').hide();

            base.unhighlight.call(this, element, errorClass, validClass);
        },
        showErrors: function (errorMap, errorList) {
            for (var i = 0; this.errorList[i]; i++) {
                var error = this.errorList[i];
                this.settings.highlight.call(this, error.element, this.settings.errorClass, this.settings.validClass, error.message);
            }
            if (this.errorList.length) {
                this.toShow = this.toShow.add(this.containers);
            }
            if (this.settings.success) {
                for (var i = 0; this.successList[i]; i++) {
                    this.showLabel(this.successList[i]);
                }
            }
            for (var i = 0, elements = this.validElements(); elements[i]; i++) {
                //fix for some grid controls which have multiple hidden fields not showing validation error
                if (!$(elements[i]).parent().find(".validate-ignore")) {
                    this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, this.settings.validClass);
                }
            }
            this.toHide = this.toHide.not(this.toShow);
            this.hideErrors();
            this.addWrapper(this.toShow).show();
        }
    });
})($);

(function ($) {
    // override jquery valid method to also call validation on new controls
    var _old = $.fn.valid;

    $.fn.valid = function () {
        const jqueryResult = _old.apply(this, arguments);

        let allValid = true;

        for (const ctrl of Object.values(this.data("agControls") ?? {})) {
            if (ctrl.validate && ctrl.validate() != null)
                allValid = false;
        }

        return jqueryResult && allValid;
    };
})($);